
 import * as React from 'react';
 import {createComponent} from '@lit/react';
 
 import {ObiLightningSnowShowersDay as ObiLightningSnowShowersDayElement} from '@oicl/openbridge-webcomponents/dist/icons/icon-lightning-snow-showers-day.js';
 
 
 

 
 export const ObiLightningSnowShowersDay = createComponent({
   react: React,
   tagName: 'obi-lightning-snow-showers-day',
   elementClass: ObiLightningSnowShowersDayElement,
   events: {
     
   }
  });
 
 